// Russian translations for src/config/release-notes.md.
// See release-notes.fr.ts for the schema.

export const releaseNotesRu: Record<string, string> = {
  '0.2.0': `### 0.2.0 — Артефакты

Новая механика поздней игры, плюсы и минусы которой игрок должен тщательно взвесить.

- **Введены артефакты** — выпадают с боссов после Подъёма 5, с большим количеством строк модификаторов на более высоких уровнях боссов. Каждый артефакт несёт положительный и отрицательный модификатор — взвешивайте их перед надеванием.
- **Улучшенный прогресс в ожидании** — улучшенное управление кадрами для предотвращения скачков урона и лечения, ведущих к неожиданным смертям
- **Никогда не готово** — множество небольших исправлений и улучшений интерфейса`,
}
